import React from 'react';
import SyncApi from 'components/SyncApi';

const SyncApiPage = () => {
  return <SyncApi />;
};

export default SyncApiPage;
